import { REQUEST_URL } from "../constants";
import { RequestUtil } from "../utils";
import { CategoryStatus, CategoryInputModel } from "../models"

export const CategoryService = {
  updateCategory,
  deleteCategory
};

async function updateCategory(code: string, status: CategoryStatus, data: CategoryInputModel) {
  const url = REQUEST_URL.UPDATE_CATEGORY.replace("{CODE}", code);

  return RequestUtil.put({ url, query: status, data: data });
}

async function deleteCategory(code: string) {
  const url = REQUEST_URL.DELETE_CATEGORY.replace("{CODE}", code);

  return RequestUtil.delete({ url });
}